'use client';

import type { FC } from 'react';

import { cn } from '@/lib/utils';

import {
    ContentText,
    type ContentTextProps,
} from '@/components/molecules/ContentText';

export interface TextContentProps {
    contentTextConfig: ContentTextProps;
}

const TextContent: FC<TextContentProps> = ({ contentTextConfig }) => (
    <ContentText
        {...contentTextConfig}
        className={cn('text-center', contentTextConfig.className)}
    />
);

export default TextContent;
